import { Component, Input, OnInit } from '@angular/core';
import { BaseAPIService } from '../Services/api.base.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../Services/util.service';
import { IDeviceMetadata } from '../Models/IDeviceMetadata';
import { IGridCols } from '../Models/IGridCols';


@Component({
  selector: 'app-device-metadata',
  standalone: false,
  templateUrl: './device-metadata.component.html',
  styleUrls: ['./device-metadata.component.scss'],
  providers: [MessageService]
})
export class DeviceMetadataComponent implements OnInit {
  cols: Array<IGridCols>;
  labels: any;
  messages: any;
  deviceMetadata: IDeviceMetadata[];
  modalReference: NgbModalRef;
  noData: boolean = false;
  isPagination: boolean = true;
  isLoading: boolean = false;
  showmodal: boolean = false;
  formInvalid: boolean = false;
  public targetSearch: string;
  _selectedColumns: Array<IGridCols>;
  filterCols: Array<IGridCols>;

  constructor(private readonly baseService: BaseAPIService, private readonly translate: TranslateService) { }

  ngOnInit() {
    this.labels = label;
    this.isLoading = true;
    this.messages = message;

    this.cols = [
      { field: 'modbusSlaveId', header: this.translate.instant(this.labels.modbusSlaveID), width: '5%', display: 'auto' },
      { field: 'release', header: this.translate.instant(this.labels.release), width: '12%', display: 'auto' },
      { field: 'pCH', header: this.translate.instant(this.labels.pch), width: '5%', display: 'auto' },
      { field: 'locationCountry', header: this.translate.instant(this.labels.locationContry), width: '8%', display: 'auto' },
      { field: 'firmwareVersion', header: this.translate.instant(this.labels.firmwareVersion), width: '12%', display: 'auto' },
      { field: 'dongleUId', display: 'none' },
      { field: 'name', display: 'none' },
      { field: 'lastConnectedOn', display: 'none' },
      { field: 'addedBy', display: 'none' },
      { field: 'addedOn', display: 'none' },
      { field: 'mask', display: 'none' },
      { field: 'poli', display: 'none' },
      { field: 'controllerTypeName', display: 'none' },
      { field: 'deviceType', display: 'none' },

    ];
    this.filterCols = this.cols.filter(col => col.display === 'auto');
    this.GetDeviceMetaDataList();
  }
  @Input() get selectedColumns(): Array<IGridCols> {
    return this._selectedColumns;
  }

  public set selectedColumns(val: Array<IGridCols>) {
    this._selectedColumns = this.filterCols.filter(col => val.includes(col));
  }
  public GetDeviceMetaDataList() {
    this.baseService.GET('/DeviceDashboard/DeviceMetadata')
      .subscribe((result: IDeviceMetadata[]) => {
        if (result !== null && result.length > 0) {
          this.deviceMetadata = result;
          this.isLoading = false;
          if (this.deviceMetadata.length < 10) {
            this.isPagination = false;
          }

        }
        else {
          this.noData = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }

  ExportDeviceMetadata() {
    this.isLoading = true;
    this.baseService.DOWNLOADGet("/DeviceDashboard/DownloadDeviceMetadata", null).subscribe((result) => {
      const fileName = `DeviceMetaData_${UtilService.FormatDate(new Date()).toString().replace(' ', '_')}.xlsx`;
      const blob = new Blob([result], { type: "application/octet-stream" });
      saveAs(blob, fileName);
      this.isLoading = false;
    });
  }

}
